import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorPageCoverPicturePlaceholder } from './EditorCoverPicture/EditorPageCoverPicturePlaceholder.tsx';
import type { EditorPageCoverPictureComponentProps } from './pageCoverPictureTypes.ts';

export const LazyEditorPageCoverPicture: LoadableType<EditorPageCoverPictureComponentProps> =
	LoadableAfterPaint<EditorPageCoverPictureComponentProps>({
		loader: async () => {
			return (
				await import(
					/* webpackChunkName: "loadable-EditorCoverPictureEditorPageCoverPicture" */ './EditorCoverPicture/EditorPageCoverPicture.tsx'
				)
			).EditorPageCoverPicture;
		},
		loading: EditorPageCoverPicturePlaceholder,
	});
